module.exports = __webpack_public_path__ + "img/5-1.46867753.png";